<template>
  <v-flex :lg2="!showFilters" md3 sm4 xs6 class="mb-4">
    <v-card
      class="mx-auto"
      hover
      max-width="230px"
      height="100%"
      flat
      :style="customStyle"
    >
      <v-row justify="start" align="stretch" no-gutters style="height: 100%">
        <v-hover>
          <template v-slot:default="{ hover }">
            <v-col cols="12" lg="12" xs="12">
              <v-row
                justify="space-between"
                align="stretch"
                no-gutters
                style="height: 100%"
              >
                <!-- <router-link :to="goToProdInfoPage"> -->
                <v-col cols="12" lg="12" xs="12">
                  <router-link :to="goToProdInfoPage">
                    <ProductImage :product="product"></ProductImage>
                  </router-link>
                </v-col>

                <v-col cols="12" lg="12" xs="12" align-self="end">
                  <v-row
                    justify="space-between"
                    align="stretch"
                    no-gutters
                    style="height: 100%"
                  >
                    <v-col cols="12" lg="12" xs="12" align-self="end">
                      <router-link :to="goToProdInfoPage">
                        <v-chip
                          v-if="!product.available_for_sale"
                          class="mt-2"
                          color="error"
                          label
                          outlined
                          text-color="error"
                          large
                        >
                          <span class="abc">
                            {{ product.available_for_sale_message }}
                          </span>
                        </v-chip>

                        <Tags :product="product"></Tags>
                        <ProductName :product="product"></ProductName>
                      </router-link>
                    </v-col>
                    <v-col
                      cols="12"
                      lg="12"
                      xs="12"
                      align-self="end"
                      class="mt-2"
                    >
                      <GridInput
                        :product="product"
                        :isBasketItem="false"
                        :isStandingOrder="isStandingOrder"
                      ></GridInput>
                    </v-col>
                  </v-row>
                </v-col>
                <!-- </router-link> -->
              </v-row>

              <!-- <v-fade-transition v-if="!product.available_for_sale">
                <v-overlay
                  v-if="hover"
                  absolute
                  opacity="0.9"
                  color="error lighten-3"
                  style="color: #000; padding: 4px"
                  >{{ product.message }}</v-overlay
                >
              </v-fade-transition> -->
            </v-col>
          </template>
        </v-hover>
      </v-row>
    </v-card>
  </v-flex>
</template>

<script>
import ProductImage from "@/components/product/ProductImage.vue";
import ProductName from "@/components/product/ProductName.vue";

import Tags from "@/components/product/Tags.vue";

import GridInput from "@/components/product/GridInput.vue";

// align-self="end"

export default {
  components: {
    ProductImage,
    ProductName,
    Tags,
    GridInput,
  },

  props: {
    product: {},
    showFilters: Boolean,
    isStandingOrder: Boolean,
  },

  computed: {
    theme() {
      console.log(this.$vuetify.theme);
      return this.$vuetify.theme.dark ? "dark" : "light";
    },

    customStyle() {
      return {
        background: this.$vuetify.theme.themes[this.theme].background,
        // "box-shadow": "0 2px 6px 0 hsla(0, 0%, 0%, 0.2) !important",
      };
    },

    goToProdInfoPage() {
      if (this.isStandingOrder) {
        return {
          name: "StandingOrderProductInfo",
          params: { id: this.product.prod_no, product: this.product },
          query: { previousPage: "StandingOrderProducts" },
        };
      }
      return {
        name: "OrdersSearchProduct",
        params: { id: this.product.prod_no, product: this.product },
        query: { previousPage: "OrdersSearch" },
      };
    },
    isProdGrid() {
      if (this.$store.getters.retrieveProductGrid) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="css" scoped>
* {
  word-break: break-word;
}

/* .v-chip{
  white-space: pre-wrap;
} */

.abc {
  max-width: 99%;
  font-size: 11px;
  font-weight: bold;
}

/* @media (min-width: 1264px) and (max-width: 1904px) { */
@media (min-width: 1264px) {
  .flex.lg2 {
    flex-basis: 20%;
    flex-grow: 0;
    max-width: 20%;
  }
}

.v-card__title {
  font-size: 14px;
  font-weight: bold;
}

.v-card__subtitle {
  padding: 4px 1em;
}

@media (min-width: 1600px) {
  .col-md-3 {
    flex: 0 0 20%;
    max-width: 20%;
  }
}

@media (max-width: 600px) {
  .rowImage {
    margin: 0 auto;
  }
}

@media (max-width: 450px) {
  .v-chip {
    white-space: normal;
  }
}
.v-card__actions {
  background-color: rgba(0, 0, 0, 0.04);
}

.transparentBG {
  background-color: transparent;
}
</style>